import { $can } from '@pendo/permissions';

function checkPermission (appId, action, entity, source = 'ANY', target = 'ANY') {
    if (!appId || !action) {
        return false;
    }

    return $can(appId)
        .entity(entity)
        .action(action)
        .source(source)
        .target(target);
}

export function canCreateEmailFromLayoutOrScratch ({ appId }) {
    // This function is used only for readability purposes,
    // it is no different from using the individual functions.
    // Every user who can create from scratch can also create from layout.
    // Not every user who can create from layout can create from scratch.
    // This means that canCreateEmailFromLayoutOrScratch == canCreateEmailFromLayout
    return canCreateEmailFromLayout({ appId }) || canCreateEmailFromScratch({ appId });
}

export function canCreateEmailFromLayout ({ appId }) {
    return checkPermission(appId, 'create', 'email', 'layout');
}

export function canCreateEmailFromScratch ({ appId }) {
    return checkPermission(appId, 'create', 'email', 'scratch');
}

export function canUpdateEmail ({ appId, source, target, email }) {
    if (!source && email?.status === 'public') {
        source = 'public';
    }

    return checkPermission(appId, 'edit', 'email', source, target);
}

export function canDeleteEmail ({ appId, source, target, email }) {
    if (!source && email?.status === 'public') {
        source = 'public';
    }

    return checkPermission(appId, 'remove', 'email', source, target);
}

export function canPublishEmail ({ appId, source, target }) {
    return checkPermission(appId, 'publish', 'email', source, target);
}
